import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { useGetConfigurationsQuery } from '@apis/mediacore/configuration'
import { useGetJobsQuery } from '@apis/mediacore/jobs'
import { makeItemsNav } from '@helpers/helper.rendering'
import useQuerySummary from '@hooks/useQuerySummary'
import React, { useState, useEffect, useLayoutEffect } from 'react'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'gatsby'
import { Division, RealEstateDataHeaderData, RealEstateDataPage, StatePropertiesSlice } from 'types'
import { useLocation } from '@reach/router'
import $ from 'jquery'
import { update } from 'react-spring'
import { getfavorites } from '@helpers/helper.favorites'
import { reduxUpdateFilters } from '@slices/propertiesSlice'
import { useDispatch, useSelector } from 'react-redux'

interface ExternalProps {
  pages?: RealEstateDataPage[]
  development_id: string
  property_id: string
  novelty_id: string
  three: Division[]
}

type CombinedProps = RealEstateDataHeaderData & ExternalProps

const Header_6 = (props: CombinedProps) => {
  //GlobalData Content
  const { global_data, pages, buttonHeart, three, spanText } = props
  const { logo } = global_data
  const { divisionPath, id: siteId } = global_data
  const API_KEY = global_data.pageConfig.keys.tokko

  const isCompiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'

  const { updaterFavorites } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!
  useLayoutEffect(() => {
    setListFavorites(getfavorites('prop', 'template-site'))
  }, [updaterFavorites])

  //Modules
  const { data: allBlogData } = useGetBlogsQuery({ site: siteId })
  const { data: allJobsData } = useGetJobsQuery({ site: siteId })
  const { allSummaryData } = useQuerySummary({ API_KEY })

  const [open, setOpen] = useState(false)

  const location = useLocation()

  const [scroll, setScroll] = useState(false)

  const [scrollPercentage, setScrollPercentage] = useState(0)

  const [updaterElement, setUpdaterElement] = useState<any>()

  useEffect(() => {
    setTimeout(() => {
      let header = document.getElementById('header-6')
      let updater = document.getElementById('updater')
      setUpdaterElement(updater)
      if (header && !updater) {
        header.style.backgroundColor = 'transparent' || '#000'
        header.style.borderColor = '#fff' || '#000'
      }
    }, 0)
  }, [location])

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = $('body').scrollTop()!
      const percentage = scrollTop
      setScrollPercentage(percentage)
    }

    $('body').on('scroll', handleScroll)
    $(document).on('click', function (event) {
      if (!$(event.target).closest('#header-6').length) {
        // Si el clic no ocurrió dentro del elemento con id "excludedElement"
        setOpen(false)
      }
    })

    return () => {
      $('body').off('scroll', handleScroll)
    }
  }, [])

  const ReFillFilters = (operation: string) => {
    return {
      location: [],
      type: [],
      operation: operation,
      environments: '',
      bedrooms: '',
      age: '',
      address: '',
      producer_id: '',
      price: {
        type: '',
        priceMin: '',
        priceMax: '',
        is_off: false,
      },
      surface: {
        type: '',
        surfaceMin: '',
        surfaceMax: '',
      },
      environments_types: [],
      generals: [],
      services: [],
      specials: [],
    }
  }

  const [listFavorites, setListFavorites] = useState(getfavorites('prop', 'template-site'))
  const countFavorites = listFavorites.length

  const dispatch = useDispatch()

  function validatePageResult(page: string) {
    if (page == 'venta' || page.includes('alquiler')) {
      dispatch(reduxUpdateFilters({ ...ReFillFilters(page) }))
    }
    throw new Error('Function not implemented.')
  }

  return (
    <header
      id="header-6"
      className={'header_6 d-flex align-items-center'}
      // style={{ backgroundColor: scrollPercentage > 100 ? 'rgba(0, 0, 0, 0.75)' : '' }}
      style={
        scrollPercentage > 100 && !updaterElement ? { backgroundColor: 'rgba(0, 0, 0, 0.75)' } : {}
      }
    >
      <Container
        className="h-100"
        fluid
      >
        <Row className="h-100">
          <Col
            className="d-flex h-100"
            lg={3}
            xs={9}
          >
            <div
              style={{ borderRight: '1px solid #fff' }}
              className="logo h-100 d-flex align-items-center pe-lg-4 pe-3"
            >
              <Link to={'/'}>
                <img
                  src={logo}
                  className="mt-auto mb-auto"
                  alt="logo-desktop"
                />
              </Link>
            </div>
            {isCompiler && (
              <div
                style={{ borderRight: '1px solid #fff' }}
                onClick={() => setOpen(true)}
                className="logo h-100 d-flex align-items-center px-3 px-lg-4 text-capitalize cursor-pointer"
              >
                {location.pathname.split('/').at(1) || spanText}
                <i className="icon-arrow-light"></i>
              </div>
            )}
          </Col>
          <Col
            lg={9}
            xs={3}
            className="d-flex justify-content-end align-items-center"
          >
            {pages ? (
              <nav>
                {makeItemsNav(allSummaryData, allBlogData, pages, allJobsData)
                  .filter((page) => !page.path.includes('detalle'))
                  .map(({ path, title }, index) => (
                    <li
                      key={index}
                      style={{ listStyle: 'none ' }}
                      onClick={() => validatePageResult(title)}
                    >
                      <Link
                        key={index}
                        className={
                          'ms-lg-5 link-nav d-lg-block d-none ' +
                          ((location.pathname.includes(path) &&
                            location.pathname !== '' &&
                            path !== '/') ||
                          (path === '/' && location.pathname === '/') ||
                          (location.pathname.toLowerCase() === divisionPath?.toLowerCase() + '/' &&
                            path === '/')
                            ? 'active'
                            : '')
                        }
                        to={(divisionPath ?? '') + path}
                      >
                        {title}
                      </Link>
                    </li>
                  ))}
                {buttonHeart?.link && (
                  <Link
                    className="btn btn-white border btn-favorites ms-5"
                    to={buttonHeart?.link}
                  >
                    {countFavorites}
                    <i className="icon-favoritos-heart-light ms-3"></i>
                  </Link>
                )}
              </nav>
            ) : (
              ''
            )}
          </Col>
        </Row>
      </Container>
      <div className={'sidebar ' + (open ? 'open' : '')}>
        <div className="content">
          <div className="header-sidebar d-flex w-100 justify-content-between">
            <h5>{'Bienvenido'}</h5>
            <div
              className="close cursor-pointer"
              onClick={() => setOpen(false)}
            >
              <i></i>
              <i></i>
            </div>
          </div>
          <div className="body-sidebar">
            <div className="current-section py-4">
              <h5>
                {' '}
                <Link to="/">
                  <img
                    src={logo}
                    alt={spanText}
                  />
                </Link>
                {/* <Link to="/">{spanText || 'Sitio'}</Link> */}
              </h5>
            </div>
            {three?.map((element: any, index: number) => (
              <Accordion
                key={index}
                defaultActiveKey={null}
              >
                <Accordion.Item eventKey={element.title}>
                  <Accordion.Header className="collapsed">
                    {' '}
                    <h5>
                      {' '}
                      0{index + 1}. {element.title}
                    </h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {/* {makeItemsNav} */}
                    {makeItemsNav(
                      allSummaryData,
                      allBlogData,
                      element.site?.content.pages,
                      allJobsData,
                    )
                      .filter((page) => !page.path.includes('detalle'))
                      .map(({ path, title }, index) => (
                        // {element.site?.content.pages.map(
                        //   (site: { path: string; title: string }, index: string) => (
                        <li
                          onClick={() => {
                            setOpen(false)
                            validatePageResult(title)
                          }}
                          key={index}
                        >
                          <Link to={element.path + path}>{title}</Link>
                        </li>
                      ))}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            ))}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header_6
